import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

interface ProsecutorsOfficeFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function ProsecutorsOfficeForm({ form, isView }: ProsecutorsOfficeFormProps) {
  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="Option"
        render={({ field }) => (
          <FormItem className="space-y-3">
            <FormLabel>Type *</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                disabled={isView}
                className="flex flex-row space-x-6"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Inquest" id="inquest" />
                  <label htmlFor="inquest" className="text-sm font-medium cursor-pointer">
                    Inquest
                  </label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Preliminary Investigation" id="preliminary" />
                  <label htmlFor="preliminary" className="text-sm font-medium cursor-pointer">
                    Preliminary Investigation
                  </label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="Case Number"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Case Number *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter case number" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Adverse Party"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Adverse Party *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter adverse party" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Date Call"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Date Call *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter date call" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Time of Call"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Time of Call *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter time of call" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Place of Detention"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Place of Detention *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter place of detention" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="Case Title"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Case Title *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter case title" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="NPS/INV Case Number"
            render={({ field }) => (
              <FormItem>
                <FormLabel>NPS/INV Case Number *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter NPS/INV case number" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Nature of Offense"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nature of Offense *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter nature of offense" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Status"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Status *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter status" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Action Taken"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Action Taken *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter action taken" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  )
}
